module.exports = __webpack_public_path__ + "media/images/emoticons/heart03-28226471661def641eb1350d129feff0.gif";